module.exports = __webpack_public_path__ + "static/media/react-original-wordmark.30047295.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/react-original-wordmark.svg
// module id = 96
// module chunks = 0